/* eslint-disable complexity */
// Copyright (c) 2016 Deere & Company

import Tab from '../../../../src/shared/state/tab';
import {getIsPinTransferEnabled} from './get-is-pin-transfer-enabled-aor';
import {hasAccess} from '../../../shared/services/security';

export const getNavigationTabs = (countObject, hasSearchResults, security) => {

    const navigationTabs = [];

    if (hasAccess(security, 'PRT', 'PRT_DEALER_REVIEW')) {

        navigationTabs.push(new Tab({
            count: countObject.registrationReview,
            label: 'REGISTRATION_REVIEW_TAB',
            route: '/products/registrations'
        }));

    }

    if (hasAccess(security, 'PRT', 'PRT_DLR_TRAN_APPROVE')) {

        navigationTabs.push(new Tab({
            count: countObject.transferApproval,
            label: 'TRANSFER_APPROVALS_TAB',
            route: '/products/transfers'
        }));

    }

    if (getIsPinTransferEnabled('dealer-recommendation')) {

        navigationTabs.push(new Tab({
            count: countObject.dealerRecommendations,
            label: 'DEALER_RECOMMENDATIONS_TAB',
            route: '/products/dealerrecommendations'
        }));

    }

    if (hasAccess(security, 'PRT', 'PRT_FACTORY_USER_PIN_PLATE')) {

        navigationTabs.push(new Tab({
            count: countObject.factoryDuplicatePinPlateCount,
            label: 'FACTORY_USERS_TAB',
            route: '/products/factory-shipping-info'
        }));

    }

    navigationTabs.push(new Tab({
        count: countObject.machineStatusUpdates,
        label: 'MACHINE_STATUS_UPDATES_WITH_COUNT',
        route: '/products/machine-status-update'
    }));

    if (hasSearchResults) {

        navigationTabs.push(new Tab({
            count: countObject.productSearch,
            label: 'SEARCH_RESULTS_TAB',
            route: '/products/search'
        }));

    }

    return navigationTabs;

};



// WEBPACK FOOTER //
// ./src/product/shared/services/product-navigation-helper.js